import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorProviderService, SelectItem, ProviderDTO} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-provider',
    templateUrl: './select-provider.component.html',
    styleUrls: ['./select-provider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectProviderComponent
        }
    ],
    standalone: false
})
export class SelectProviderComponent implements OnChanges, ControlValueAccessor {

    constructor(private configuratorProviderService: ConfiguratorProviderService) {
    }

    provider: string | null = null;
    providers: SelectItem[] = [];
    private providerDetails: ProviderDTO[] = [];
    @Output() providerSelected = new EventEmitter<ProviderDTO | null>();

    @Input() datastore: string;
    @Input() value: string | null = null;
    @Output() change = new EventEmitter<SelectItem | null>();
    @Input() disabled = false;
    @Input() cache = false;
    touched = false;

    onChange = (value) => {
    };
    onTouched = () => {
    };

    private loadProvider() {
        if (this.datastore?.length > 0) {
            this.configuratorProviderService.getAllProvidersUsingGET(this.datastore).subscribe(res => {
                this.providerDetails = res || [];
                this.providers = [];
                res.forEach(item => {
                    this.providers.push({
                        value: item.code,
                        label: item.name
                    });
                });
                this.updateValue();
            });
        }
    }

    writeValue(codeProvider: any): void {
        this.value = codeProvider;
        this.updateValue();
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.updateValue();
        }
        if (changes.datastore && this.datastore != null) {
            this.loadProvider();
        }
    }

    private updateValue() {
        if (this.providers == null) {
            return;
        }
        if (this.value) {
            const selectedProvider = this.providers.find(d => d.value == this.value);
            this.provider = (selectedProvider?.value as string) || null;
        } else {
            this.provider = null;
        }
    }

    providerChange() {
        if (!this.disabled) {
            const nextValue = this.provider || null;
            this.value = nextValue;
            this.onChange(nextValue);
            this.markAsTouched();
            const selectedProvider = this.providers.find(d => d.value === nextValue) || null;
            this.change.emit(selectedProvider);
            this.providerSelected.emit(this.providerDetails.find(item => item.code === nextValue) || null);
        }
    }

}
